module.exports = __webpack_public_path__ + "media/images/webpage/clips/spot-53328dc3426150edb0c8b2d7d3f9276d.webp";